import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import {
  REPORT_MIN_MATCHES,
  reportCtaState,
  matchesUntilUnlock,
} from "../../helpers/reportGate";
import ActiveBuyerReportComingSoonModal from "./ActiveBuyerReportComingSoonModal";
import { downloadIconTwo } from "@/images";
import {
  downloadBuyerMatchReport,
  buyerMatchReportErrorMessage,
} from "../../services/v2/buyerMatchReport";

export { REPORT_MIN_MATCHES };

const BUTTON_STYLE = {
  marginTop: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 40,
  padding: 0,
  letterSpacing: "unset",
};

const ReportCTA = ({ inventoryId, totalMatches = 0 }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  // Three states, not a bare unlocked/locked flag: "coming-soon" (the report
  // isn't launched yet - the modal below is the right explanation regardless
  // of match count) and "locked" (launched, but this property hasn't
  // cleared REPORT_MIN_MATCHES) look identical to a naive unlocked check,
  // but ActionDropdown/InventoryDetails already tell them apart with a
  // disabled item + "Unlocks at N - X to go" for "locked". This button did
  // not, and popped the coming-soon modal for both - misleading once the
  // report is actually launched.
  const state = reportCtaState(totalMatches);
  const unlocked = state === "unlocked";
  const locked = state === "locked";

  // Reset the coming-soon modal when the selected property changes, so it
  // doesn't stay open (referencing the old property) if left open while
  // switching properties.
  useEffect(() => {
    setShowComingSoon(false);
  }, [inventoryId]);

  const openReport = () => {
    if (!inventoryId) return;
    downloadBuyerMatchReport(inventoryId).catch((err) =>
      toast.error(buyerMatchReportErrorMessage(err))
    );
  };

  return (
    <>
      <Button
        className="btn-grey w-100"
        data-tour="download-report-match"
        disabled={locked}
        title={
          locked
            ? `Unlocks at ${REPORT_MIN_MATCHES} buyer matches - ${matchesUntilUnlock(totalMatches)} to go`
            : undefined
        }
        onClick={
          unlocked
            ? openReport
            : locked
              ? undefined
              : () => setShowComingSoon(true)
        }
        style={BUTTON_STYLE}
      >
        Download Report
        <img
          src={downloadIconTwo}
          style={{ width: 12, height: 12, marginLeft: 8 }}
          alt=""
        />
      </Button>
      {state === "coming-soon" && (
        <ActiveBuyerReportComingSoonModal
          show={showComingSoon}
          onHide={() => setShowComingSoon(false)}
        />
      )}
    </>
  );
};

export default ReportCTA;
